import React from 'react'
import { Field, getIn } from 'formik'
import { useTranslation } from 'react-i18next'
import styles from 'components/Shared/ErrorMessage/ErrorMessage.module.css'
import classNames from 'classnames'

export function ErrorMessage ({ name, notRequiredTouchedToError, className }) {
  const { t } = useTranslation()

  function toString (error) {
    if (typeof error === 'string') {
      return t(error)
    }
    if (typeof error === 'object') {
      return t(error.key, error.values)
    }
    return ''
  }

  return <Field name={name}>
    {({ form }) => {
      const error = getIn(form.errors, name)
      const touch = getIn(form.touched, name)
      const msg = (notRequiredTouchedToError || touch) && error ? toString(error) : ''
      return <StyledMessage message={msg} className={className}/>
    }}
  </Field>
}

export function CustomWarningMessageText ({ message }) {
  return <StyledMessage message={message} className={styles.customWarning}/>
}

export function InfoMessageText ({ message }) {
  return <StyledMessage message={message} className={styles.infoMessage}/>
}

function StyledMessage ({ message, className }) {
  return <span className={classNames(styles.error, className)}>
    {message}
  </span>
}